import React from 'react';
import { AppGridLayout, AppTableSearch, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar, AppFilter } from 'qcc';
import api, { } from "api";
import AppUserSelect from "../../public/AppUserSelect";
import { Icon } from 'antd';

const getFilter = (roleId?: number) => {
  return [{
    keyName: 'roleId',
    lable: '',
    field: 'role_id',
    min: '',
    max: '',
    opr: '',
    value: `${roleId}`,
    list: [],
    searchItemType: 'projectFilter'
  }] as AppFilter[]
}

export default class extends React.Component<{ roleId?: number }> {
  state = {}

  add = async () => {
    let userSelect = <AppUserSelect callback={this.handleAdd} isMult />
    AppAction.openDialog(userSelect, { title: '选择用户', fullScreen: true });
  }

  handleAdd = async (list?: any[]) => {
    let id = this.props.roleId;
    let ids = list.map((data: any) => { return data.id as number })
    let mode = "roleUser";
    await api.role.addUserRole({ mode, id, ids })
    AppAction.successMsg('操作成功！');
    this.afterSave();
  }



  delete = async (data?: any) => {
    if (await AppAction.confirm('您确定要移除该用户吗？')) {
      await api.role.deleteUserRole({ id: data.id });
      AppAction.successMsg('操作成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid} style={{ padding: 0 }}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <div style={{ paddingLeft: 20 }}>用户列表</div>
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="00010105" type='primary' action={this.add} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable sqlId='sql.userRole.grid'
            queryDataList={getFilter(this.props.roleId)}
            orderBy="a.id"
            paging>
            <AppTable.ColIndex />
            <AppTable.Col title='用户名称' field='user_name' width={160} />
            <AppTable.Col title='用户编码' field='account' width={160} />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                <AppButton type='link' label='移除' actionCode="00010105" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/application/role/RoleUserIndex.tsx